
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import Toasted from 'vue-toasted';
import { WindowType } from '../../util';
import { AccountApiClient, AccountEdit } from '../backend/backendapi';
import { initClient } from '../../api';

declare var window: WindowType;

Vue.use(Toasted);

@Component
export default class AccountEditor extends Vue {
  readonly service = initClient(AccountApiClient);
  vm: AccountEdit | null = null;
  editAccountIdFromRazor: number = 0;
  isAdd = true;

  get isMaxUser(): boolean {
    return window.application.permissions.account.isAccountShowMaxUsers;
  }

  mounted() {
    window.addEventListener('load', () => {  // window.application.treeNodeId only available after everything is loaded
      this.editAccountIdFromRazor = window.application.treeNodeId;
      this.fetchModel();
    });
  }

  fetchModel() {
    let treeNodeId = this.editAccountIdFromRazor;
    if (treeNodeId != 0) {
      this.isAdd = false;
    }
    if (this.vm?.treeNode?.dbId !== undefined) {
      treeNodeId = this.vm.treeNode.dbId;
    }

    this.service.getAccountEdit(treeNodeId)
        .then(data => {
          this.vm = data as AccountEdit;
        });
  }

  postSave() {
    if (!this.vm) {
      return;
    }
    this.service.saveAccountEdit(this.vm)
        .then(_ => {
          if (this.isAdd)
            this.$toasted.success(this.$t('txtAccountSuccess').toString()).goAway(2000);
          else
            this.$toasted.success(this.$t('txtSuccess').toString()).goAway(2000);
        });
  }
}
